<div class="login-container">
  <div class="header">
    <img src="assets/images/common/logo.png" [alt]="'LogChain' | translate" />
  </div>
  <div class="main-container">
    <div class="login-card align-center-item">
      <div class="header-cart mb-5">
        <div class="top">
          <div class="left">
            {{ "Welcome to" | translate }} <b>Log</b>Chain!
          </div>
          <div class="right">{{ getToday() }}</div>
        </div>
        <div class="title text-center mt-3">{{ "Login" | translate }}</div>
        <ngb-alert
          class="mt-3"
          *ngIf="errorMsg != ''"
          [type]="'danger'"
          [dismissible]="false"
          >{{ errorMsg }}</ngb-alert
        >
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="email"
              [placeholder]="'Enter your email' | translate"
            />
          </div>
          <small
            *ngIf="formControl.email.touched && formControl.email.invalid"
            class="form-text text-danger"
            >{{ getEmailErrorMessage() }}</small
          >
        </div>
        <div class="form-group mb-0">
          <div class="input-group">
            <input
              [type]="hide ? 'password' : 'text'"
              class="form-control"
              formControlName="password"
              [placeholder]="'Enter your password' | translate"
            />
            <div class="input-group-append eye-icon">
              <span
                (click)="hide = !hide"
                class="input-group-text"
                style="border: none"
                ><mat-icon>{{
                  hide ? "visibility_off" : "visibility"
                }}</mat-icon></span
              >
            </div>
          </div>
          <small
            *ngIf="formControl.password.touched && formControl.password.invalid"
            class="form-text text-danger"
            >{{ getPasswordErrorMessage() }}</small
          >
        </div>
        <div class="forgot-password-link text-right">
          <span (click)="goToResetPassword()">{{
            "Forgot password" | translate
          }}</span>
        </div>
        <div class="d-grid">
          <button
            [disabled]="loginForm.invalid"
            class="btn btn-primary"
            (click)="login()"
          >
            <span *ngIf="!isLoading">{{
              "LOGIN" | translate | uppercase
            }}</span>
            <div *ngIf="isLoading" class="spinner-border" role="status"></div>
          </button>
        </div>
        <div class="divider">
          <span>OR</span>
        </div>
        <div class="d-grid">
          <button
            type="button"
            expand="block"
            fill="outline"
            class="btn btn-primary"
            (click)="onLoginMicrosoft()"
          >
            Login with Microsoft
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
